module.exports = __webpack_public_path__ + "static/media/fat-logo2.6f7bea97.png";